import * as types from './authTypes';

export const initialState = {
	clientApplication: null,
	initialized: false,
	authenticated: false,       // Authenticated
	authenticating: false,      // Authenticating
	username: null,             // Signed in user
	email: null,				// Signed in user email
	avatar: null,				// Signed in Users Profile Pic
	error: null,                // Authentication Error
};

export default function authReducer(state = initialState, action) {
	switch (action.type) {
		case types.APP_MSAL_SETUP: {
			return {
				...state,
				clientApplication: action.payload.clientApplication,
				initialized: true,
				authenticating: action.payload.authenticating,
				error: action.payload.error
			};
		}
		case types.APP_AUTHENTICATE: {
			return {
				...state,
				clientApplication: action.payload.clientApplication,
				initialized: action.payload.initialized,
				authenticated: action.payload.authenticated,
				authenticating: action.payload.authenticating,
				username: action.payload.username,
				email: action.payload.email,
				error: action.payload.error ? action.payload.error : null
			};
		}
		case types.APP_AVATAR: {
			return {
				...state,
				avatar: action.payload.avatar
			}
		}
		default:
			return state;
	}
};

